import React, { useState, useEffect } from "react"
import { Fragment } from "react"
import {
  Alert,
  Row,
  Col,
  Form,
  Label,
  Input,
  ButtonGroup,
  Button,
} from "reactstrap"
import LabelChargeData from "../../components/Common/labelChargeData"
import { useTranslation } from "react-i18next"
import { is_empty } from "../../config/validate"
//redux
import { useSelector, useDispatch } from "react-redux"
import { editLimitUser, editSupplierClean } from "../../store/actions"
import showToast from "../../components/Common/viewNotification"
const SupplierLimitForm = props => {
  const { t } = useTranslation()
  const [limit, setLimit] = useState(0)
  const dispatch = useDispatch()
  // eslint-disable-next-line react/prop-types
  const { onClosing, currentSupplier, onLoad } = props
  const { loading, error, responseSupplier } = useSelector(state => ({
    loading: state.Suppliers.loadingSave,
    responseSupplier: state.Suppliers.response,
    error: state.Suppliers.error,
  }))
  useEffect(() => {
    if (currentSupplier) {
      setLimit(currentSupplier.userLimit)
    }
  }, [currentSupplier])
  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
      dispatch(editSupplierClean())
    }
  }, [error])
  useEffect(() => {
    if (responseSupplier !== null) {
      showToast(
        currentSupplier?.name + " " + t("supplier:limitUserSuccess"),
        "success",
        t("supplier:lblModalLimit")
      )
      dispatch(editSupplierClean())
      onLoad()
    }
  }, [responseSupplier])
  const submitHandler = e => {
    const json = {
      supplierId: currentSupplier.supplierId,
      userLimit: limit,
    }
    e.preventDefault()
    dispatch(editLimitUser(json))
  }
  return (
    <Fragment>
      <Alert color="primary">
        {currentSupplier === null ? "" : currentSupplier.name}
      </Alert>
      <Form onSubmit={submitHandler}>
        <Row>
          <Col xs={12}>
            <div className="mb-3">
              <Label className="form-label">
                {t("supplier:lblModalLimit")}
              </Label>
              <Input
                placeholder="userLimit"
                name="userLimit"
                type="number"
                onChange={e => setLimit(e.target.value)}
                value={limit ? limit : 0}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <LabelChargeData
              label={""}
              showloading={loading}
              title={t("global:registerloading")}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-end">
              <ButtonGroup>
                <Button
                  type="submit"
                  className="btn btn-info save-user"
                  disabled={loading}
                >
                  <i className=" fas fa-save me-1 "> {"  "}</i>
                  {t("supplier:btnModalSave")}
                </Button>
                <button
                  type="button"
                  className="btn btn-danger "
                  disabled={loading}
                  onClick={() => {
                    onClosing(false)
                  }}
                >
                  {" "}
                  {t("global:close")}
                </button>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
      </Form>
    </Fragment>
  )
}

export default SupplierLimitForm
